import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentReason } from '@libs/store';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

const NUMBER_OF_COLUMNS = 3;

@Component({
  selector: 'lib-initial-reason',
  imports: [CommonModule, SvgIconComponent, LottieComponent],
  templateUrl: './initial-reason.component.html',
  styleUrl: './initial-reason.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InitialReasonComponent {
  public readonly loading = signal<boolean>(false);
  public readonly items = signal<AppointmentReason[]>([]);
  public readonly selectedItems = signal<AppointmentReason[]>([]);
  public readonly numberOfRows = computed(() => Math.floor(this.items().length / NUMBER_OF_COLUMNS));

  public lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  @Input() public set isLoading(value: boolean) {
    this.loading.set(value);
  }

  @Input() public set initialReasons(value: AppointmentReason[]) {
    this.items.set(value);
  }

  @Input() public set selectedReasons(value: AppointmentReason[]) {
    this.selectedItems.set(value);
  }

  @Output() public readonly itemSelected = new EventEmitter<AppointmentReason>();
  @Output() public readonly itemDeselected = new EventEmitter<AppointmentReason>();

  public selectItem(item: AppointmentReason): void {
    this.itemSelected.emit(item);
  }

  public deselectItem(item: AppointmentReason): void {
    this.itemDeselected.emit(item);
  }

  public isSelected(item: AppointmentReason): boolean {
    return this.selectedItems().some((selected) => selected.progressNoteId == null && selected.code === item.code);
  }
}
